module.exports = __webpack_public_path__ + "static/media/ico_phone.04ce9de9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Contacts/imgs/ico_phone.svg
// module id = 1685
// module chunks = 0